import { render, staticRenderFns } from "./ProductsEditor.vue?vue&type=template&id=a5e5c490&scoped=true&"
import script from "./ProductsEditor.vue?vue&type=script&lang=ts&"
export * from "./ProductsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsEditor.vue?vue&type=style&index=0&id=a5e5c490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e5c490",
  null
  
)

export default component.exports